<p-tabMenu [model]="tabMenuItems" [activeItem]="activeItem"></p-tabMenu>
<router-outlet></router-outlet>